import { render } from "./AddExpensesModal.vue?vue&type=template&id=6976f9e0"
import script from "./AddExpensesModal.vue?vue&type=script&lang=js"
export * from "./AddExpensesModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__